export default 
[
    {
        id: 1,
        isRoot: true,
        children: [],
        type: 'list',
        listName: 'Inbox',
        items: []
    },
    {
        id: 2,
        isRoot: true,
        children: [4,6],
        type: 'list',
        listName: 'Travel',
        items: []
    },
    {
        id: 3,
        isRoot: true,
        children: [],
        type: 'list',
        listName: 'Music',
        items: []
    },
    {
        id: 4,
        isRoot: false,
        children: [7],
        type: 'list',
        listName: 'Food',
        items: []
    },
    {
        id: 5,
        isRoot: true,
        children: [],
        type: 'list',
        listName: 'Books',
        items: []
    },
    {
        id: 6,
        isRoot: false,
        children: [],
        type: 'list',
        listName: 'Hotels',
        items: []
    },
    {
        id: 7,
        isRoot: false,
        children: [],
        type: 'list',
        listName: 'Recipes',
        items: []
    }
]
